import { defineComponent as _defineComponent } from 'vue'
import { computed, onActivated, onUnmounted, onDeactivated } from 'vue';
import { useToolbarStore } from '@/store/toolbarStore';
// eslint-disable-next-line import/no-cycle
import { useProformaStore } from '@/modules/proforma/stores/proformaStore';
import { useApplicationStore } from '@/store/applicationStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProformaTabs',
  props: {
    proformaId: null
  },
  setup(__props: any) {

const props = __props as {
  proformaId: string | number;
};

const proformaStore = useProformaStore();
const toolbarStore = useToolbarStore();
const applicationStore = useApplicationStore();



const tabs = computed(() => {
  const result = [];
  if (
    applicationStore.globalSettings?.SGL_USE_INQUIRY === 1 &&
    applicationStore.user.internal &&
    applicationStore.userRight('PR2.ACCESS')
  ) {
    result.push({ caption: 'DETAILS', routeName: 'proformaDetails' });
    result.push({ caption: 'DOCUMENTS', routeName: 'proformaDocs' });
    result.push({ caption: 'EMAILS', routeName: 'proformaEmailList' });
  }
  return result;
});

onActivated(async () => {
  await proformaStore.fetchProformaWindow(props.proformaId);
  toolbarStore.setToolbarTitle(
    `${proformaStore.proformaWindow?.proformaInfo?.PROFORMA_NUMBER} (${proformaStore.proformaWindow?.proformaInfo?.VESSEL_NAME})`
  );
});

onUnmounted(() => {
  toolbarStore.setBackNavigation(undefined);
  toolbarStore.setToolbarTitle('');
});

onDeactivated(() => {
  toolbarStore.setBackNavigation(undefined);
  toolbarStore.setToolbarTitle('');
});

return { __sfc: true,proformaStore, toolbarStore, applicationStore, props, tabs }
}

})